__turbopack_context__.v({
  "itemImageListItem": "ItemImage-module__1_7-_G__itemImageListItem",
});
